import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import { hot } from 'react-hot-loader/root';

import { LoadingScreen } from 'components/loadingScreen';
import Calculator from 'pages/calculator';
import Report from 'pages/report';
import UserLibrary from 'pages/userLibrary';
// import ExampleLibrary from 'pages/exampleLibrary';
import FourOhFour from 'pages/404';
import Landing from 'pages/landing';
import ErrorBoundary from './ErrorBoundary';

const Router = () => {
  useEffect(() => {
    sessionStorage.setItem('session-progress', 'true');
  }, []);

  // const Calculator = lazy(() => import('pages/calculator'));
  // const Report = lazy(() => import('pages/report'));
  // const UserLibrary = lazy(() => import('pages/userLibrary'));
  const ExampleLibrary = lazy(() => import('pages/exampleLibrary'));
  // const FourOhFour = lazy(() => import('pages/404'));

  return (
    <BrowserRouter>
      <Landing>
        <ErrorBoundary>
          <Suspense fallback={<LoadingScreen show={true} />}>
            <Switch>
              <Route exact path='/' component={Calculator}>
                <Redirect to='/calculator' />
              </Route>
              <Route exact path='/calculator' component={Calculator} />
              <Route exact path='/results' component={Report} />
              <Route exact path='/user-library' component={UserLibrary} />
              <Route exact path='/example-library' component={ExampleLibrary} />
              {/* <Route path="/home" component={Home} /> */}
              <Route component={FourOhFour} />
            </Switch>
          </Suspense>
        </ErrorBoundary>
      </Landing>
    </BrowserRouter>
  );
};

export default hot(Router);
